import { createReducer } from 'typesafe-actions';
import { CompareValidationActions, RESET_VALIDATION, SET_VALIDATION_ERROR } from '../actions';

export type ValidationRules = 'productListCount' | 'listsCount';

export const validationError = createReducer<ValidationRules | null, CompareValidationActions>(null)
  .handleAction(SET_VALIDATION_ERROR, (_, { payload }) => payload)
  .handleAction(RESET_VALIDATION, () => null);
